import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListOcpiSessionIdCell } from './transaction-list-ocpi-session-id.cell';
import { TransactionListOcpiSessionIdHeader } from './transaction-list-ocpi-session-id.header';

export const TransactionListOcpiSessionIdColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['ocpiSessionId']
> = {
  enableSorting: false,
  header: TransactionListOcpiSessionIdHeader,
  cell: TransactionListOcpiSessionIdCell,
  meta: { maxWidth: '130px', width: '120px', minWidth: '80px' },
};
